// extracted by mini-css-extract-plugin
export default {"notePage":"Notes_notePage__8MI1K"};